import { includes, pipe, prop } from 'lodash/fp';

import { MODULE_NAME } from './constants';

const moduleSelector = prop(MODULE_NAME);

export const loadedScriptsSelector = pipe(moduleSelector, prop('loadedScripts'));

/**
 * @param {string} scriptName
 */
export const loadedScriptSelector = (scriptName) =>
	pipe(loadedScriptsSelector, includes(scriptName));
